import { render, staticRenderFns } from "./PartialPaymentBannerForHotelPage.vue?vue&type=template&id=748d2138&lang=pug&"
import script from "./PartialPaymentBannerForHotelPage.vue?vue&type=script&lang=ts&"
export * from "./PartialPaymentBannerForHotelPage.vue?vue&type=script&lang=ts&"
import style0 from "./PartialPaymentBannerForHotelPage.vue?vue&type=style&index=0&id=748d2138&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports